// Iter122ey · Helper per gating sezioni/widget in base al piano condominio.
// Fonte di verità = `user.plan_features` (array di chiavi allineate a `SECTION_KEYS`
// nel backend `plan_utils.py`).
//
// Regole:
//  - super_admin e admin dello Studio Izzo (tenant_id="studio") → SEMPRE tutto abilitato.
//  - Se `plan_features` è assente/vuoto → fallback aperto (compat con vecchi tenant senza matrice).
//  - Altrimenti: la feature è abilitata solo se presente nell'array.
export function hasPlanFeature(user, key) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  if (user.tenant_id === "studio") return true;
  const feats = Array.isArray(user.plan_features) ? user.plan_features : [];
  if (feats.length === 0) return true; // legacy fallback
  return feats.includes(key);
}
